import { getDefaultLanguageWithGlobal, getDirectionByUrl } from "../helper/module";
import i18n from 'i18next';
import {store} from '../Redux/store';
import { restClient } from "../service/API/axios";


export const changeDirection = () => {    
    store.dispatch({
        type: "changeDirection",
        direction: getDirectionByUrl(),
        fullDirection: getDirectionByUrl(),
        lang: getDefaultLanguageWithGlobal(global.config.defaultLanguage).lang
    })
    i18n.changeLanguage(getDefaultLanguageWithGlobal(global.config.defaultLanguage).lang);
};

 

export const rtlLtrCssPatchSelector = (direction= "ltr" , lang = 'en') => {
    let patch = null
    if(['fr'].includes(lang)){
      // patch exist
      patch = lang;
    }
  
    window["toggleTheme"](direction , patch , global.appVersion)

    if(!localStorage.getItem("lang") ) {
      localStorage.setItem( "lang" ,   getDefaultLanguageWithGlobal(global.config.defaultLanguage).lang)
      restClient.defaults.headers["Accept-Language"] = getDefaultLanguageWithGlobal(global.config.defaultLanguage).lang
      
    }
  
    if(!localStorage.getItem("lang") ) {
      localStorage.setItem( "lang" ,   getDefaultLanguageWithGlobal(global.config.defaultLanguage).lang)
      restClient.defaults.headers["Accept-Language"] = getDefaultLanguageWithGlobal(global.config.defaultLanguage).lang
      
    }
  };
  